webpackJsonp([1],Array(72).concat([
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(119);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(118);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vue = __webpack_require__(18);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(12);

var _vuex2 = _interopRequireDefault(_vuex);

var _api = __webpack_require__(82);

var _api2 = _interopRequireDefault(_api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var store = new _vuex2.default.Store({
  state: {
    isAdmin: false,
    isLoading: false,
    user: {},
    reports: [],
    reportTemplates: [],
    allReports: [] // List of reports for *all* users. Only available to admin.
  },

  mutations: {
    setIsAdmin: function setIsAdmin(state, isAdmin) {
      state.isAdmin = isAdmin;
    },
    setAllReports: function setAllReports(state, reports) {
      state.allReports = reports;
    },
    setUser: function setUser(state, user) {
      state.user = user;
    },
    setReports: function setReports(state, reports) {
      reports = reports.map(function (r) {
        if (typeof r.tod === 'string') {
          r.tod = r.tod.split(',').map(function (i) {
            return parseInt(i, 10);
          });
        }
        if (typeof r.dow === 'string') {
          r.dow = r.dow.split(',').map(function (i) {
            return parseInt(i, 10);
          });
        }
        return r;
      });
      state.reports = reports;
    },
    setReportTemplates: function setReportTemplates(state, reportTemplates) {
      reportTemplates = reportTemplates.map(function (t) {
        if (typeof t.tod === 'string') {
          t.tod = t.tod.split(',').map(function (i) {
            return parseInt(i, 10);
          });
        }
        return t;
      });
      state.reportTemplates = reportTemplates;
    },
    addNewTemplate: function addNewTemplate(state) {
      state.reportTemplates.push({
        id: null,
        data: {
          images: []
        }
      });
    },
    addNewReport: function addNewReport(state) {
      state.reports.push({});
    },
    setIsLoading: function setIsLoading(state, value) {
      state.isLoading = value;
    }
  },

  actions: {
    getAppState: function getAppState(_ref) {
      var _this = this;

      var commit = _ref.commit;
      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var config, templates;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commit('setIsLoading', true);
                _context.next = 3;
                return _api2.default.get('config');

              case 3:
                config = _context.sent;

                commit('setIsAdmin', config.isAdmin);
                commit('setUser', config.user);
                commit('setReports', config.reports);
                templates = config.reportTemplates.filter(function (t) {
                  return t.public;
                }).map(function (t) {
                  if (!t.tod) {
                    t.tod = [];
                  }
                  if (!t.dow) {
                    t.dow = [];
                  }
                  return t;
                });

                commit('setReportTemplates', templates);
                commit('setIsLoading', false);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getAllReports: function getAllReports(_ref2) {
      var _this2 = this;

      var commit = _ref2.commit;
      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        var reports;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _api2.default.get('all-reports');

              case 2:
                reports = _context2.sent;

                commit('setAllReports', reports);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    setAllReports: function setAllReports(_ref3, reports) {
      var _this3 = this;

      var dispatch = _ref3.dispatch;
      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _api2.default.post('all-reports', { reports: reports });

              case 2:
                dispatch('getAppState');
                dispatch('getAllReports');

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    getReportTemplates: function getReportTemplates(_ref4) {
      var _this4 = this;

      var commit = _ref4.commit;
      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
        var templates;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _api2.default.get('report-templates');

              case 2:
                templates = _context4.sent;

                commit('setReportTemplates', templates);

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    addReportTemplate: function addReportTemplate(_ref5, template) {
      var _this5 = this;

      var commit = _ref5.commit,
          dispatch = _ref5.dispatch;
      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5() {
        return _regenerator2.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _api2.default.post('report-templates', {
                  name: template.name,
                  name_short: template.name_short,
                  public: true,
                  data: template.data,
                  intro: template.intro,
                  close: template.close,
                  tod: template.tod,
                  dow: template.dow
                });

              case 2:
                dispatch('getAppState');

              case 3:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    deleteReportTemplate: function deleteReportTemplate(_ref6, template) {
      var _this6 = this;

      var commit = _ref6.commit,
          dispatch = _ref6.dispatch;
      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6() {
        return _regenerator2.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return _api2.default.post('report-templates/' + template.id + '/delete');

              case 2:
                dispatch('getAppState');

              case 3:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    updateReportTemplate: function updateReportTemplate(_ref7, template) {
      var _this7 = this;

      var commit = _ref7.commit,
          dispatch = _ref7.dispatch;
      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7() {
        return _regenerator2.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return _api2.default.post('report-templates/' + template.id + '/update', {
                  name: template.name,
                  name_short: template.name_short,
                  public: true,
                  data: template.data,
                  intro: template.intro,
                  close: template.close,
                  tod: template.tod,
                  dow: template.dow
                });

              case 2:
                dispatch('getAppState');

              case 3:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this7);
      }))();
    },
    addReport: function addReport(_ref8, report) {
      var _this8 = this;

      var dispatch = _ref8.dispatch;
      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8() {
        return _regenerator2.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return _api2.default.post('mine', report);

              case 2:
                dispatch('getAppState');

              case 3:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this8);
      }))();
    },
    updateReport: function updateReport(_ref9, report) {
      var _this9 = this;

      var dispatch = _ref9.dispatch;
      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9() {
        return _regenerator2.default.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return _api2.default.post('mine/' + report.id + '/update', report);

              case 2:
                dispatch('getAppState');

              case 3:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this9);
      }))();
    },
    deleteReport: function deleteReport(_ref10, report) {
      var _this10 = this;

      var dispatch = _ref10.dispatch;
      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee10() {
        return _regenerator2.default.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return _api2.default.post('mine/' + report.id + '/delete', report);

              case 2:
                dispatch('getAppState');

              case 3:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this10);
      }))();
    },
    sendReportNow: function sendReportNow(_ref11, report) {
      var _this11 = this;

      var dispatch = _ref11.dispatch,
          commit = _ref11.commit;
      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee11() {
        return _regenerator2.default.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                commit('setIsLoading', true);
                _context11.next = 3;
                return _api2.default.post('mine/' + report.id + '/send', report);

              case 3:
                _context11.next = 5;
                return dispatch('getAppState');

              case 5:
                commit('setIsLoading', false);

              case 6:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this11);
      }))();
    }
  },

  getters: {
    reportTemplateIDs: function reportTemplateIDs(state) {
      return state.reportTemplates.map(function (t) {
        return t.id;
      });
    }
  }
});

exports.default = store;

/***/ }),
/* 73 */,
/* 74 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 75 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 76 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(172)
  __webpack_require__(171)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(111),
  /* template */
  __webpack_require__(258),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(42);

var _promise2 = _interopRequireDefault(_promise);

var _assign = __webpack_require__(1);

var _assign2 = _interopRequireDefault(_assign);

var _vue = __webpack_require__(18);

var _vue2 = _interopRequireDefault(_vue);

var _vueResource = __webpack_require__(286);

var _vueResource2 = _interopRequireDefault(_vueResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueResource2.default);

_vue2.default.http.interceptors.push(function (request, next) {
  console.log(request);
  request.params.access_token = '4543fd141b6af93a6cb8';
  request.credentials = true;
  next();
});

var root = 'https://api.ansergy.com/email-reports';

var uniqueRequests = {};
function ensureUniqueRequest(token, request) {
  if (uniqueRequests[token]) {
    uniqueRequests[token].abort();
  }
  uniqueRequests[token] = request;
}

function request(method, path, options) {
  options = (0, _assign2.default)({}, options, {
    before: ensureUniqueRequest('email-reports')
  });

  return new _promise2.default(function (resolve, reject) {
    var url = root + '/' + path;
    _vue2.default.http[method](url, options).then(function (response) {
      resolve(response.body);
    }, function (response) {
      console.error('error', response);
      reject(response);
    });
  });
}

function get(path, options) {
  return request('get', path, options);
}

function post(path, options) {
  return request('post', path, options);
}

exports.default = { get: get, post: post, root: root };

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(18);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(77);

var _App2 = _interopRequireDefault(_App);

var _bootstrapVue = __webpack_require__(73);

var _bootstrapVue2 = _interopRequireDefault(_bootstrapVue);

var _store = __webpack_require__(72);

var _store2 = _interopRequireDefault(_store);

__webpack_require__(75);

__webpack_require__(74);

__webpack_require__(76);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_bootstrapVue2.default); // The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

_vue2.default.config.productionTip = false;

/* eslint-disable no-new */
new _vue2.default({
  store: _store2.default,
  el: '#app',
  template: '<App/>',
  components: { App: _App2.default }
});

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(117);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _assign = __webpack_require__(1);

var _assign2 = _interopRequireDefault(_assign);

var _formatValue = __webpack_require__(80);

var _formatValue2 = _interopRequireDefault(_formatValue);

var _tableHeader = __webpack_require__(224);

var _tableHeader2 = _interopRequireDefault(_tableHeader);

var _tablePagination = __webpack_require__(225);

var _tablePagination2 = _interopRequireDefault(_tablePagination);

var _tableBody = __webpack_require__(221);

var _tableBody2 = _interopRequireDefault(_tableBody);

var _tableFooter = __webpack_require__(222);

var _tableFooter2 = _interopRequireDefault(_tableFooter);

var _stable = __webpack_require__(214);

var _stable2 = _interopRequireDefault(_stable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'datatable',
  components: { TableHeader: _tableHeader2.default, TableBody: _tableBody2.default, TableFooter: _tableFooter2.default, TablePagination: _tablePagination2.default },
  props: ['columns', 'rows', 'title', 'order', 'orderBy', 'page', 'totalPages'],
  data: function data() {
    return {
      OrderBy: this.orderBy,
      Order: this.order
    };
  },
  computed: {
    Columns: function Columns() {
      var order = this.Order;
      var orderBy = this.OrderBy;
      return this.columns.map(function (c) {
        return (0, _assign2.default)({}, c, { order: c.id === orderBy ? order : null });
      });
    },
    Rows: function Rows() {
      var rows = this.rows.slice();

      if (typeof this.OrderBy !== 'undefined') {
        var orderBy = this.OrderBy;
        var order = this.Order === 'ASC' ? 1 : -1;
        _stable2.default.inplace(rows, function (a, b) {
          var va = a[orderBy];
          var vb = b[orderBy];
          if (va < vb) {
            return order * -1;
          }
          if (va > vb) {
            return order * 1;
          }
          return 0;
        });
      }

      var columns = this.Columns;

      return rows.map(function (row) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = (0, _getIterator3.default)(columns), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var column = _step.value;

            var id = column.id;
            var type = column.type;
            row[id] = (0, _formatValue2.default)(row[id], type);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return row;
      });
    }
  },
  methods: {
    setPage: function setPage(page) {
      this.$emit('setPage', page);
    },
    toggleOrder: function toggleOrder(id) {
      if (this.OrderBy !== id) {
        this.Order = 'DESC';
      } else {
        this.Order = this.Order === 'ASC' ? 'DESC' : 'ASC';
      }
      this.OrderBy = id;
      this.$emit('setOrder', { order: id, direction: this.Order });
    }
  }
};

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tableRow = __webpack_require__(226);

var _tableRow2 = _interopRequireDefault(_tableRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'table-body',
  props: ['columns', 'rows'],
  components: { TableRow: _tableRow2.default }
}; //
//
//
//
//
//
//
//
//
//

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _downloadCSV2 = __webpack_require__(41);

var _downloadCSV3 = _interopRequireDefault(_downloadCSV2);

var _downloadPDF2 = __webpack_require__(78);

var _downloadPDF3 = _interopRequireDefault(_downloadPDF2);

var _downloadXLS2 = __webpack_require__(79);

var _downloadXLS3 = _interopRequireDefault(_downloadXLS2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'table-footer',
  props: ['columns', 'rows'],
  methods: {
    toggleOrder: function toggleOrder(id) {
      if (this.OrderBy !== id) {
        this.Order = 'DESC';
      } else {
        this.Order = this.Order === 'ASC' ? 'DESC' : 'ASC';
      }
      this.OrderBy = id;
    },
    downloadCSV: function downloadCSV() {
      (0, _downloadCSV3.default)(this.columns, this.rows);
    },
    downloadPDF: function downloadPDF() {
      (0, _downloadPDF3.default)(this.columns, this.rows);
    },
    downloadXLS: function downloadXLS() {
      (0, _downloadXLS3.default)(this.columns, this.rows);
    }
  }
}; //
//
//
//
//
//
//
//
//

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tetherTooltip = __webpack_require__(216);

var _tetherTooltip2 = _interopRequireDefault(_tetherTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//

var ASC = 'ASC';
var DESC = 'DESC';
exports.default = {
  name: 'table-header-cell',
  props: ['data'],
  data: function data() {
    return { tooltip: null };
  },

  computed: {
    sortOrderClass: function sortOrderClass() {
      if (this.data.order === ASC) {
        return 'sort-order-asc';
      }
      if (this.data.order === DESC) {
        return 'sort-order-desc';
      }
      return 'sort-order-none';
    }
  },
  methods: {},
  mounted: function mounted() {
    this.tooltip = new _tetherTooltip2.default({
      target: this.$el,
      content: this.data.tooltip
    });
  }
};

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tableHeaderCell = __webpack_require__(223);

var _tableHeaderCell2 = _interopRequireDefault(_tableHeaderCell);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'table-header',
  props: ['columns', 'order', 'orderBy', 'title'],
  components: { TableHeaderCell: _tableHeaderCell2.default },
  methods: {
    toggleOrder: function toggleOrder(id) {
      this.$emit('toggleOrder', id);
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'table-pagination',
  props: ['page', 'totalPages'],
  methods: {
    setPage: function setPage(page) {
      page = Math.max(Math.min(page, this.totalPages), 1);
      this.$emit('setPage', page);
    },
    onNextPage: function onNextPage() {
      this.setPage(this.page + 1);
    },
    onPreviousPage: function onPreviousPage() {
      this.setPage(this.page - 1);
    },
    pageClasses: function pageClasses(page) {
      if (page === this.page) {
        return 'page-current';
      }
      return '';
    }
  },
  computed: {
    pages: function pages(_ref) {
      var page = _ref.page,
          totalPages = _ref.totalPages;

      var pages = [];
      var offset = 2;
      var start = page - offset;
      var right = totalPages - Math.max(page, totalPages - offset);
      var end = page + offset - right;

      if (start > 1) {
        for (var i = 1; i < Math.min(offset + 1, start); ++i) {
          start += 1;
          pages.push(i);
        }
      }

      for (var _i = start; _i <= page; ++_i) {
        if (_i > 0 && _i <= totalPages) {
          pages.push(_i);
        }
      }

      for (var _i2 = page + 1; _i2 <= end; ++_i2) {
        if (_i2 > 0 && _i2 <= totalPages) {
          pages.push(_i2);
        }
      }

      if (end < totalPages) {
        for (var _i3 = totalPages - right + 1; _i3 <= totalPages; ++_i3) {
          pages.push(_i3);
        }
      }

      return pages;
    }
  }
};

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//


exports.default = {
  name: 'table-row',
  props: ['columns', 'data']
};

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'AtomSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1000
    },
    size: {
      type: Number,
      default: 60
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    circleStyle: function circleStyle() {
      return {
        color: this.color,
        fontSize: this.size * 0.24 + 'px'
      };
    },
    lineStyle: function lineStyle() {
      return {
        animationDuration: this.animationDuration + 'ms',
        borderLeftWidth: this.size / 25 + 'px',
        borderTopWidth: this.size / 25 + 'px',
        borderLeftColor: this.color
      };
    }
  }
};

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(1);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//

exports.default = {
  name: 'BreedingRhombusSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 2000
    },
    size: {
      type: Number,
      default: 150
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      animationBaseName: 'breeding-rhombus-spinner-animation-child',
      rhombusesNum: 8
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    rhombusStyle: function rhombusStyle() {
      return {
        height: this.size / 7.5 + 'px',
        width: this.size / 7.5 + 'px',
        animationDuration: this.animationDuration + 'ms',
        top: this.size / 2.3077 + 'px',
        left: this.size / 2.3077 + 'px',
        backgroundColor: this.color
      };
    },
    rhombusesStyles: function rhombusesStyles() {
      var rhombusesStyles = [];
      var delayModifier = this.animationDuration * 0.05;

      for (var i = 1; i <= this.rhombusesNum; i++) {
        rhombusesStyles.push((0, _assign2.default)({
          animationDelay: delayModifier * (i + 1) + 'ms'
        }, this.rhombusStyle));
      }

      return rhombusesStyles;
    },
    bigRhombusStyle: function bigRhombusStyle() {
      return {
        height: this.size / 3 + 'px',
        width: this.size / 3 + 'px',
        animationDuration: '' + this.animationDuration,
        top: this.size / 3 + 'px',
        left: this.size / 3 + 'px',
        backgroundColor: this.color
      };
    }
  }

};

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(1);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//

exports.default = {
  name: 'CirclesToRhombusesSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1200
    },
    circleSize: {
      type: Number,
      default: 15
    },
    color: {
      type: String,
      default: '#fff'
    },
    circlesNum: {
      type: Number,
      default: 3
    }
  },

  computed: {
    circleMarginLeft: function circleMarginLeft() {
      return this.circleSize * 1.125;
    },
    spinnertStyle: function spinnertStyle() {
      return {
        height: this.circleSize + 'px',
        width: (this.circleSize + this.circleMarginLeft) * this.circlesNum + 'px'
      };
    },
    circleStyle: function circleStyle() {
      return {
        borderColor: this.color,
        animationDuration: this.animationDuration + 'ms',
        height: this.circleSize + 'px',
        width: this.circleSize + 'px',
        marginLeft: this.circleMarginLeft + 'px'
      };
    },
    circlesStyles: function circlesStyles() {
      var circlesStyles = [];
      var delay = 150;

      for (var i = 1; i <= this.circlesNum; i++) {
        var style = (0, _assign2.default)({
          animationDelay: i * delay + 'ms'
        }, this.circleStyle);

        if (i === 1) {
          style.marginLeft = 0;
        }

        circlesStyles.push(style);
      }

      return circlesStyles;
    }
  }
};

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(1);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//

exports.default = {
  name: 'FingerprintSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1500
    },
    size: {
      type: Number,
      default: 60
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      ringsNum: 9,
      containerPadding: 2
    };
  },


  computed: {
    outerRingSize: function outerRingSize() {
      return this.size - this.containerPadding * 2;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        padding: this.containerPadding + 'px'
      };
    },
    ringStyle: function ringStyle() {
      return {
        borderTopColor: this.color,
        animationDuration: this.animationDuration + 'ms'
      };
    },
    ringsStyles: function ringsStyles() {
      var ringsStyles = [];
      var ringBase = this.outerRingSize / this.ringsNum;
      var ringInc = ringBase;

      for (var i = 1; i <= this.ringsNum; i++) {
        var style = (0, _assign2.default)({
          animationDelay: i * 50 + 'ms',
          height: ringBase + (i - 1) * ringInc + 'px',
          width: ringBase + (i - 1) * ringInc + 'px'
        }, this.ringStyle);
        ringsStyles.push(style);
      }

      return ringsStyles;
    }
  }
};

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(35);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'FlowerSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 2500
    },
    size: {
      type: Number,
      default: 70
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      smallDotName: 'flower-spinner-small-dot-' + Date.now(),
      bigDotName: 'flower-spinner-big-dot-' + Date.now()
    };
  },


  computed: {
    dotSize: function dotSize() {
      return this.size / 7;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        width: this.size + 'px',
        height: this.size + 'px'
      };
    },
    dotsContainerStyle: function dotsContainerStyle() {
      return {
        width: this.dotSize + 'px',
        height: this.dotSize + 'px'
      };
    },
    smallerDotStyle: function smallerDotStyle() {
      return {
        background: this.color,
        animationDuration: this.animationDuration + 'ms',
        animationName: this.smallDotName
      };
    },
    biggerDotStyle: function biggerDotStyle() {
      return {
        background: this.color,
        animationDuration: this.animationDuration + 'ms',
        animationName: this.bigDotName
      };
    }
  },

  watch: {
    size: {
      handler: 'updateAnimation',
      immediate: true
    },
    color: {
      handler: 'updateAnimation',
      immediate: true
    }
  },

  beforeDestroy: function beforeDestroy() {
    _utils2.default.removeKeyframes(this.smallDotName);
    _utils2.default.removeKeyframes(this.bigDotName);
  },


  methods: {
    updateAnimation: function updateAnimation() {
      _utils2.default.removeKeyframes(this.smallDotName);
      _utils2.default.appendKeyframes(this.smallDotName, this.generateSmallDotKeyframes());
      _utils2.default.removeKeyframes(this.bigDotName);
      _utils2.default.appendKeyframes(this.bigDotName, this.generateBigDotKeyframes());
    },
    generateSmallDotKeyframes: function generateSmallDotKeyframes() {
      return '0%, 100% {\n                    box-shadow: 0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ';\n                  }\n                  25%, 75% {\n                    box-shadow: ' + this.dotSize * 1.4 + 'px 0 0 ' + this.color + ',\n                                -' + this.dotSize * 1.4 + 'px 0 0 ' + this.color + ',\n                                0 ' + this.dotSize * 1.4 + 'px 0 ' + this.color + ',\n                                0 -' + this.dotSize * 1.4 + 'px 0 ' + this.color + ',\n                                ' + this.dotSize + 'px -' + this.dotSize + 'px 0 ' + this.color + ',\n                                ' + this.dotSize + 'px ' + this.dotSize + 'px 0 ' + this.color + ',\n                                -' + this.dotSize + 'px -' + this.dotSize + 'px 0 ' + this.color + ',\n                                -' + this.dotSize + 'px ' + this.dotSize + 'px 0 ' + this.color + ';\n\n                  }\n                  100% {\n                    box-shadow: 0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ';\n                  }';
    },
    generateBigDotKeyframes: function generateBigDotKeyframes() {
      return '0%, 100% {\n                    box-shadow: 0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ';\n                  }\n                  50% {\n                    transform: rotate(180deg);\n                  }\n                  25%, 75% {\n                    box-shadow: ' + this.dotSize * 2.6 + 'px 0 0 ' + this.color + ',\n                                -' + this.dotSize * 2.6 + 'px 0 0 ' + this.color + ',\n                                0 ' + this.dotSize * 2.6 + 'px 0 ' + this.color + ',\n                                0 -' + this.dotSize * 2.6 + 'px 0 ' + this.color + ',\n                                ' + this.dotSize * 1.9 + 'px -' + this.dotSize * 1.9 + 'px 0 ' + this.color + ',\n                                ' + this.dotSize * 1.9 + 'px ' + this.dotSize * 1.9 + 'px 0 ' + this.color + ',\n                                -' + this.dotSize * 1.9 + 'px -' + this.dotSize * 1.9 + 'px 0 ' + this.color + ',\n                                -' + this.dotSize * 1.9 + 'px ' + this.dotSize * 1.9 + 'px 0 ' + this.color + ';\n\n                  }\n                  100% {\n                    transform: rotate(360deg);\n                    box-shadow: 0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ',\n                                0 0 0 ' + this.color + ';\n                  }';
    }
  }
}; //
//
//
//
//
//
//
//
//
//

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//

exports.default = {
  name: 'FulfillingBouncingCircleSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 4000
    },
    size: {
      type: Number,
      default: 60
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        animationDuration: this.animationDuration + 'ms'
      };
    },
    orbitStyle: function orbitStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        borderColor: this.color,
        borderWidth: this.size * 0.03 + 'px',
        animationDuration: this.animationDuration + 'ms'
      };
    },
    circleStyle: function circleStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        borderColor: this.color,
        color: this.color,
        borderWidth: this.size * 0.1 + 'px',
        animationDuration: this.animationDuration + 'ms'
      };
    }
  }
};

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//

exports.default = {
  name: 'FulfillingSquareSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 4000
    },
    size: {
      type: Number,
      default: 50
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        borderColor: this.color
      };
    },
    spinnerInnerStyle: function spinnerInnerStyle() {
      return {
        backgroundColor: this.color
      };
    }
  }
};

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(1);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//

exports.default = {
  name: 'HalfCircleSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1000
    },
    size: {
      type: Number,
      default: 60
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    circleStyle: function circleStyle() {
      return {
        borderWidth: this.size / 10 + 'px',
        animationDuration: this.animationDuration + 'ms'
      };
    },
    circle1Style: function circle1Style() {
      return (0, _assign2.default)({
        borderTopColor: this.color
      }, this.circleStyle);
    },
    circle2Style: function circle2Style() {
      return (0, _assign2.default)({
        borderBottomColor: this.color
      }, this.circleStyle);
    }
  }
};

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(1);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//

exports.default = {
  name: 'HollowDotsSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1000
    },
    dotSize: {
      type: Number,
      default: 15
    },
    dotsNum: {
      type: Number,
      default: 3
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    horizontalMargin: function horizontalMargin() {
      return this.dotSize / 2;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.dotSize + 'px',
        width: (this.dotSize + this.horizontalMargin * 2) * this.dotsNum + 'px'
      };
    },
    dotStyle: function dotStyle() {
      return {
        animationDuration: this.animationDuration + 'ms',
        width: this.dotSize + 'px',
        height: this.dotSize + 'px',
        margin: '0 ' + this.horizontalMargin + 'px',
        borderWidth: this.dotSize / 5 + 'px',
        borderColor: this.color
      };
    },
    dotsStyles: function dotsStyles() {
      var dotsStyles = [];
      var delayModifier = 0.3;
      var basicDelay = 1000;

      for (var i = 1; i <= this.dotsNum; i++) {
        var style = (0, _assign2.default)({
          animationDelay: basicDelay * i * delayModifier + 'ms'
        }, this.dotStyle);

        dotsStyles.push(style);
      }

      return dotsStyles;
    }
  }
};

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(1);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//

exports.default = {
  name: 'IntersectingCirclesSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1200
    },
    size: {
      type: Number,
      default: 70
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    circleSize: function circleSize() {
      return this.size / 2;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        width: this.size + 'px',
        height: this.size + 'px'
      };
    },
    spinnerBlockStyle: function spinnerBlockStyle() {
      return {
        animationDuration: this.animationDuration + 'ms',
        width: this.circleSize + 'px',
        height: this.circleSize + 'px'
      };
    },
    circleStyle: function circleStyle() {
      return {
        borderColor: this.color
      };
    },
    circleStyles: function circleStyles() {
      var _this = this;

      var circlesPositions = [{ top: 0, left: 0 }, { left: this.circleSize * -0.36 + 'px', top: this.circleSize * 0.2 + 'px' }, { left: this.circleSize * -0.36 + 'px', top: this.circleSize * -0.2 + 'px' }, { left: 0, top: this.circleSize * -0.36 + 'px' }, { left: this.circleSize * 0.36 + 'px', top: this.circleSize * -0.2 + 'px' }, { left: this.circleSize * 0.36 + 'px', top: this.circleSize * 0.2 + 'px' }, { left: 0, top: this.circleSize * 0.36 + 'px' }];

      return circlesPositions.map(function (cp) {
        return (0, _assign2.default)(cp, _this.circleStyle);
      });
    }
  }
};

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(1);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'LoopingRhombusesSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 2500
    },
    rhombusSize: {
      type: Number,
      default: 15
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      rhombusesNum: 3
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.rhombusSize + 'px',
        width: this.rhombusSize * 4 + 'px'
      };
    },
    rhombusStyle: function rhombusStyle() {
      return {
        height: this.rhombusSize + 'px',
        width: this.rhombusSize + 'px',
        backgroundColor: this.color,
        animationDuration: this.animationDuration + 'ms',
        left: this.rhombusSize * 4 + 'px'
      };
    },
    rhombusesStyles: function rhombusesStyles() {
      var rhombusesStyles = [];
      var delay = -this.animationDuration / 1.5;

      for (var i = 1; i <= this.rhombusesNum; i++) {
        var style = (0, _assign2.default)({
          animationDelay: i * delay + 'ms'
        }, this.rhombusStyle);

        rhombusesStyles.push(style);
      }

      return rhombusesStyles;
    }
  }
};

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//

exports.default = {
  name: 'OrbitSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1000
    },
    size: {
      type: Number,
      default: 50
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    orbitStyle: function orbitStyle() {
      return {
        borderColor: this.color,
        animationDuration: this.animationDuration + 'ms'
      };
    }
  }
};

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(35);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'PixelSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1500
    },
    size: {
      type: Number,
      default: 70
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      animationName: 'pixel-spinner-animation-' + Date.now()
    };
  },


  computed: {
    pixelSize: function pixelSize() {
      return this.size / 7;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        width: this.size + 'px',
        height: this.size + 'px'
      };
    },
    spinnerInnerStyle: function spinnerInnerStyle() {
      return {
        animationDuration: this.animationDuration + 'ms',
        animationName: this.animationName,
        width: this.pixelSize + 'px',
        height: this.pixelSize + 'px',
        backgroundColor: this.color,
        color: this.color,
        boxShadow: '\n                        ' + this.pixelSize * 1.5 + 'px ' + this.pixelSize * 1.5 + 'px 0 0,\n                        ' + this.pixelSize * -1.5 + 'px ' + this.pixelSize * -1.5 + 'px 0 0,\n                        ' + this.pixelSize * 1.5 + 'px ' + this.pixelSize * -1.5 + 'px 0 0,\n                        ' + this.pixelSize * -1.5 + 'px ' + this.pixelSize * 1.5 + 'px 0 0,\n                        0 ' + this.pixelSize * 1.5 + 'px 0 0,\n                        ' + this.pixelSize * 1.5 + 'px 0 0 0,\n                        ' + this.pixelSize * -1.5 + 'px 0 0 0,\n                        0 ' + this.pixelSize * -1.5 + 'px 0 0\n                      '
      };
    }
  },

  watch: {
    size: {
      handler: 'updateAnimation',
      immediate: true
    }
  },

  mounted: function mounted() {
    this.updateAnimation();
  },
  beforeDestroy: function beforeDestroy() {
    _utils2.default.removeKeyframes(this.animationName);
  },


  methods: {
    updateAnimation: function updateAnimation() {
      _utils2.default.removeKeyframes(this.animationName);
      _utils2.default.appendKeyframes(this.animationName, this.generateKeyframes());
    },
    generateKeyframes: function generateKeyframes() {
      return '\n        50% {\n          box-shadow:  ' + this.pixelSize * 2 + 'px ' + this.pixelSize * 2 + 'px 0 0,\n                       ' + this.pixelSize * -2 + 'px ' + this.pixelSize * -2 + 'px 0 0,\n                       ' + this.pixelSize * 2 + 'px ' + this.pixelSize * -2 + 'px 0 0,\n                       ' + this.pixelSize * -2 + 'px ' + this.pixelSize * 2 + 'px 0 0,\n                       0 ' + this.pixelSize + 'px 0 0,\n                       ' + this.pixelSize + 'px 0 0 0,\n                       ' + this.pixelSize * -1 + 'px 0 0 0,\n                       0 ' + this.pixelSize * -1 + 'px 0 0;\n        }\n\n\n        75% {\n          box-shadow:  ' + this.pixelSize * 2 + 'px ' + this.pixelSize * 2 + 'px 0 0,\n                       ' + this.pixelSize * -2 + 'px ' + this.pixelSize * -2 + 'px 0 0,\n                       ' + this.pixelSize * 2 + 'px ' + this.pixelSize * -2 + 'px 0 0,\n                       ' + this.pixelSize * -2 + 'px ' + this.pixelSize * 2 + 'px 0 0,\n                       0 ' + this.pixelSize + 'px 0 0,\n                       ' + this.pixelSize + 'px 0 0 0,\n                       ' + this.pixelSize * -1 + 'px 0 0 0,\n                       0 ' + this.pixelSize * -1 + 'px 0 0;\n        }\n\n        100% {\n          transform: rotate(360deg);\n        }';
    }
  }
}; //
//
//
//
//
//

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(1);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'RadarSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 2000
    },
    size: {
      type: Number,
      default: 110
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      circlesNum: 4
    };
  },


  computed: {
    borderWidth: function borderWidth() {
      return this.size * 5 / 110;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    circleStyle: function circleStyle() {
      return {
        animationDuration: this.animationDuration + 'ms'
      };
    },
    circleInnerContainerStyle: function circleInnerContainerStyle() {
      return {
        borderWidth: this.borderWidth + 'px'
      };
    },
    circleInnerStyle: function circleInnerStyle() {
      return {
        borderLeftColor: this.color,
        borderRightColor: this.color,
        borderWidth: this.borderWidth + 'px'
      };
    },
    circlesStyles: function circlesStyles() {
      var circlesStyles = [];
      var delay = this.animationDuration * 0.15;

      for (var i = 0; i < this.circlesNum; i++) {
        circlesStyles.push((0, _assign2.default)({
          padding: this.borderWidth * 2 * i + 'px',
          animationDelay: (i === this.circlesNum - 1 ? 0 : delay) + 'ms'
        }, this.circleStyle));
      }

      return circlesStyles;
    }
  }
};

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(1);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'ScalingSquaresSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1250
    },
    size: {
      type: Number,
      default: 65
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      squaresNum: 4
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        animationDuration: this.animationDuration + 'ms'
      };
    },
    squareStyle: function squareStyle() {
      return {
        height: this.size * 0.25 / 1.3 + 'px',
        width: this.size * 0.25 / 1.3 + 'px',
        animationDuration: this.animationDuration + 'ms',
        borderWidth: this.size * 0.04 / 1.3 + 'px',
        borderColor: this.color
      };
    },
    squaresStyles: function squaresStyles() {
      var squaresStyles = [];

      for (var i = 1; i <= this.squaresNum; i++) {
        squaresStyles.push((0, _assign2.default)({}, this.squareStyle));
      }

      return squaresStyles;
    }
  }
};

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(1);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'SelfBuildingSquareSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 6000
    },
    size: {
      type: Number,
      default: 40
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      squaresNum: 9
    };
  },


  computed: {
    squareSize: function squareSize() {
      return this.size / 4;
    },
    initialTopPosition: function initialTopPosition() {
      return -this.squareSize * 2 / 3;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        top: -this.initialTopPosition + 'px',
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    squareStyle: function squareStyle() {
      return {
        height: this.squareSize + 'px',
        width: this.squareSize + 'px',
        top: this.initialTopPosition + 'px',
        marginRight: this.squareSize / 3 + 'px',
        marginTop: this.squareSize / 3 + 'px',
        animationDuration: this.animationDuration + 'ms',
        background: this.color
      };
    },
    squaresStyles: function squaresStyles() {
      var squaresStyles = [];
      var delaysMultipliers = [6, 7, 8, 3, 4, 5, 0, 1, 2];
      var delayModifier = this.animationDuration * 0.05;

      for (var i = 0; i < this.squaresNum; i++) {
        squaresStyles.push((0, _assign2.default)({
          animationDelay: delayModifier * delaysMultipliers[i] + 'ms'
        }, this.squareStyle));
      }

      return squaresStyles;
    }
  }
};

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(1);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//

exports.default = {
  name: 'SemipolarSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 2000
    },
    size: {
      type: Number,
      default: 65
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      ringsNum: 5
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    ringStyle: function ringStyle() {
      return {
        animationDuration: this.animationDuration + 'ms',
        borderTopColor: this.color,
        borderLeftColor: this.color
      };
    },
    ringsStyles: function ringsStyles() {
      var ringsStyles = [];
      var delayModifier = 0.1;
      var ringWidth = this.size * 0.05;
      var positionIncrement = ringWidth * 2;
      var sizeDecrement = this.size * 0.2;

      for (var i = 0; i < this.ringsNum; i++) {
        var computedSize = this.size - sizeDecrement * i + 'px';
        var computedPosition = positionIncrement * i + 'px';
        var style = (0, _assign2.default)({
          animationDelay: this.animationDuration * delayModifier * (this.ringsNum - i - 1) + 'ms',
          height: computedSize,
          width: computedSize,
          left: computedPosition,
          top: computedPosition,
          borderWidth: ringWidth + 'px'
        }, this.ringStyle);
        ringsStyles.push(style);
      }

      return ringsStyles;
    }
  }
};

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(35);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'SpringSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 3000
    },
    size: {
      type: Number,
      default: 70
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      animationName: 'spring-spinner-animation-' + Date.now()
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    spinnerPartStyle: function spinnerPartStyle() {
      return {
        height: this.size / 2 + 'px',
        width: this.size + 'px'
      };
    },
    rotatorStyle: function rotatorStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        borderRightColor: this.color,
        borderTopColor: this.color,
        borderWidth: this.size / 7 + 'px',
        animationDuration: this.animationDuration + 'ms',
        animationName: this.animationName
      };
    }
  },

  watch: {
    size: {
      handler: 'updateAnimation',
      immediate: true
    },
    color: {
      handler: 'updateAnimation',
      immediate: true
    }
  },

  mounted: function mounted() {
    this.updateAnimation();
  },
  beforeDestroy: function beforeDestroy() {
    _utils2.default.removeKeyframes(this.animationName);
  },


  methods: {
    updateAnimation: function updateAnimation() {
      _utils2.default.removeKeyframes(this.animationName);
      _utils2.default.appendKeyframes(this.animationName, this.generateKeyframes());
    },
    generateKeyframes: function generateKeyframes() {
      return '\n          0% {\n            border-width: ' + this.size / 7 + 'px;\n          }\n          25% {\n            border-width: ' + this.size / 23.33 + 'px;\n          }\n          50% {\n            transform: rotate(115deg);\n            border-width: ' + this.size / 7 + 'px;\n          }\n          75% {\n            border-width: ' + this.size / 23.33 + 'px;\n           }\n          100% {\n           border-width: ' + this.size / 7 + 'px;\n          }';
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(1);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'SwappingSquaresSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1000
    },
    size: {
      type: Number,
      default: 65
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      animationBaseName: 'swapping-squares-animation-child',
      squaresNum: 4
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    squareStyle: function squareStyle() {
      return {
        height: this.size * 0.25 / 1.3 + 'px',
        width: this.size * 0.25 / 1.3 + 'px',
        animationDuration: this.animationDuration + 'ms',
        borderWidth: this.size * 0.04 / 1.3 + 'px',
        borderColor: this.color
      };
    },
    squaresStyles: function squaresStyles() {
      var squaresStyles = [];
      var delay = this.animationDuration * 0.5;

      for (var i = 1; i <= this.squaresNum; i++) {
        squaresStyles.push((0, _assign2.default)({
          animationDelay: (i % 2 === 0 ? delay : 0) + 'ms'
        }, this.squareStyle));
      }

      return squaresStyles;
    }
  }
};

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//

exports.default = {
  name: 'TrinityRingsSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1500
    },
    size: {
      type: Number,
      default: 60
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      containerPadding: 3
    };
  },


  computed: {
    outerRingSize: function outerRingSize() {
      return this.size - this.containerPadding * 2;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        padding: this.containerPadding + 'px'
      };
    },
    ring1Style: function ring1Style() {
      return {
        height: this.outerRingSize + 'px',
        width: this.outerRingSize + 'px',
        borderColor: this.color,
        animationDuration: this.animationDuration + 'ms'
      };
    },
    ring2Style: function ring2Style() {
      return {
        height: this.outerRingSize * 0.65 + 'px',
        width: this.outerRingSize * 0.65 + 'px',
        borderColor: this.color,
        animationDuration: this.animationDuration + 'ms'
      };
    },
    ring3Style: function ring3Style() {
      return {
        height: this.outerRingSize * 0.1 + 'px',
        width: this.outerRingSize * 0.1 + 'px',
        borderColor: this.color,
        animationDuration: this.animationDuration + 'ms'
      };
    }
  }
};

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(12);

var _vueMultiselect = __webpack_require__(71);

var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);

var _vue = __webpack_require__(18);

var _vue2 = _interopRequireDefault(_vue);

var _vueNavTabs = __webpack_require__(285);

var _vueNavTabs2 = _interopRequireDefault(_vueNavTabs);

var _reportList = __webpack_require__(248);

var _reportList2 = _interopRequireDefault(_reportList);

var _epicSpinners = __webpack_require__(162);

var _allReports = __webpack_require__(247);

var _allReports2 = _interopRequireDefault(_allReports);

var _reportTemplateList = __webpack_require__(250);

var _reportTemplateList2 = _interopRequireDefault(_reportTemplateList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

_vue2.default.use(_vueNavTabs2.default);

exports.default = {
  name: 'app',
  components: { vueMultiselect: _vueMultiselect2.default, reportList: _reportList2.default, reportTemplateList: _reportTemplateList2.default, allReports: _allReports2.default, OrbitSpinner: _epicSpinners.OrbitSpinner },
  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['isAdmin', 'isLoading', 'user'])),
  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['getAppState'])),
  mounted: function mounted() {
    this.getAppState();
  }
};

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _ansergyDatatable = __webpack_require__(220);

var _ansergyDatatable2 = _interopRequireDefault(_ansergyDatatable);

var _downloadCSV = __webpack_require__(41);

var _downloadCSV2 = _interopRequireDefault(_downloadCSV);

var _csvParse = __webpack_require__(159);

var _csvParse2 = _interopRequireDefault(_csvParse);

var _vuex = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
  name: 'all-reports',
  components: { datatable: _ansergyDatatable2.default },
  data: function data() {
    return {
      file: null,
      importColumns: [],
      importRows: []
    };
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['allReports']), {
    columns: function columns() {
      return [{ id: 'user_email', label: 'Email', tooltip: 'Email where the report will be sent' }, { id: 'dow', label: 'DOW', tooltip: 'Day-of-week when the report will be sent' },
      // { id: 'tod', label: 'TOD', tooltip: 'Time-of-day when the report will be sent' },
      // { id: 'tod_template', label: 'TOD - Template', tooltip: 'Time-of-day that the template uses' },
      { id: 'name', label: 'Report Name', tooltip: 'Name of the report to be sent' }];
    }
  }),
  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['getAllReports', 'setAllReports']), {
    onExport: function onExport() {
      (0, _downloadCSV2.default)(this.columns, this.allReports);
    },
    onImport: function onImport(e) {
      var _this = this;

      var files = e.target.files || e.dataTransfer.files;
      var reader = new FileReader();
      reader.onload = function (e) {
        _this.data = e.target.result;
        (0, _csvParse2.default)(e.target.result, function (err, output) {
          if (err) {
            console.error(err);
          }
          _this.importRows = output.slice(1, output.length).map(function (row) {
            var result = {};
            for (var index in row) {
              result[_this.columns[index].id] = row[index];
            }
            return result;
          });
        });
      };
      reader.readAsText(files[0]);
    }
  }),
  mounted: function mounted() {
    this.getAllReports();
  }
};

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//

exports.default = {
  name: 'report-list'
};

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(12);

var _vueMultiselect = __webpack_require__(71);

var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);

var _vuedraggable = __webpack_require__(288);

var _vuedraggable2 = _interopRequireDefault(_vuedraggable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'report-template-form',
  components: { vueMultiselect: _vueMultiselect2.default, draggable: _vuedraggable2.default },
  props: {
    template: {}
  },
  data: function data() {
    return {
      imagesExpanded: true,
      hours: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24],
      days: [1, 2, 3, 4, 5, 6, 7]
    };
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['reportTemplates']), (0, _vuex.mapGetters)(['reportTemplateIDs']), {
    images: {
      get: function get() {
        return this.template.data.images;
      },
      set: function set(images) {
        this.template.data.images = images;
      }
    },
    dow: function dow() {
      if (!this.template) {
        return [];
      }
      if (typeof this.template.dow === 'string') {
        return this.template.dow.split(',').map(function (f) {
          return parseInt(f, 10);
        });
      }
      return this.template.dow;
    },
    tod: function tod() {
      if (!this.template) {
        return [];
      }
      if (typeof this.template.tod === 'string') {
        return this.template.tod.split(',').map(function (f) {
          return parseInt(f, 10);
        });
      }
      return this.template.tod;
    }
  }),
  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['addReport', 'updateReport']), (0, _vuex.mapActions)(['deleteReportTemplate', 'addReportTemplate', 'updateReportTemplate']), {
    onCancel: function onCancel() {
      this.$emit('cancel');
    },
    onSave: function onSave() {
      this.editing = false;
      if (this.template.id) {
        this.updateReportTemplate(this.template);
      } else {
        this.addReportTemplate(this.template);
      }
      this.$emit('save');
    },
    toggleImagesExpanded: function toggleImagesExpanded() {
      this.imagesExpanded = !this.imagesExpanded;
    },
    setDays: function setDays(days) {
      this.template.dow = days;
      this.$forceUpdate();
    },
    setHours: function setHours(hours) {
      this.template.tod = hours;
      this.$forceUpdate();
    },
    onDeleteImage: function onDeleteImage(image) {
      var images = this.template.data.images;
      var index = images.indexOf(image);
      if (index > -1) {
        images.splice(index, 1);
      }
    },
    onAddImage: function onAddImage() {
      this.template.data.images.push({});
    },
    onDelete: function onDelete() {
      if (!confirm('\nAre you sure you want to delete this template?\nReports using this template will also be deleted\n      ')) {
        return;
      }
      this.deleteReportTemplate(this.template);
    }
  })
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(12);

var _reportTemplate = __webpack_require__(251);

var _reportTemplate2 = _interopRequireDefault(_reportTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'report-template-list',
  components: { reportTemplate: _reportTemplate2.default },
  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['reportTemplates', 'allReports'])),
  methods: (0, _extends3.default)({}, (0, _vuex.mapMutations)(['addNewTemplate']))
};

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _reportTemplateForm = __webpack_require__(249);

var _reportTemplateForm2 = _interopRequireDefault(_reportTemplateForm);

var _vuex = __webpack_require__(12);

var _extend = __webpack_require__(163);

var _extend2 = _interopRequireDefault(_extend);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'report-template',
  props: {
    template: {},
    isEditing: {
      default: false,
      type: Boolean
    }
  },
  components: { reportTemplateForm: _reportTemplateForm2.default },
  computed: {
    images: function images() {
      return this.template.data.images;
    }
  },
  data: function data() {
    return {
      editing: this.isEditing,
      isExpanded: false
    };
  },

  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['addReportTemplate', 'deleteReportTemplate']), {
    onEdit: function onEdit() {
      this.editing = true;
    },
    templateName: function templateName(template) {
      return '<strong>' + template.id + '</strong> | <span>' + template.name + '</span> | <span>' + template.name_short + '</span>';
    },
    onCopy: function onCopy() {
      var copy = (0, _extend2.default)({}, this.template);
      delete copy.id;
      copy.name = copy.name + ' - Copy';
      copy.name_short = copy.name_short + '_copy';
      this.addReportTemplate(copy);
    },
    onDelete: function onDelete() {
      this.deleteReportTemplate(this.template);
    },
    onToggleExpand: function onToggleExpand() {
      this.isExpanded = !this.isExpanded;
    }
  })
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 165 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 166 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 167 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 168 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 169 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 170 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 171 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 172 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 173 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 174 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 175 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 176 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 177 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 178 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 179 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 180 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 181 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 182 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 183 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 184 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 185 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 186 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 187 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 188 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 189 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 190 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 191 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 192 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 193 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 194 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 195 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 196 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 197 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 198 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(191)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(84),
  /* template */
  __webpack_require__(277),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(169)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(85),
  /* template */
  __webpack_require__(256),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-14eed19b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(175)
  __webpack_require__(174)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(261),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-315694d4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(164)
  __webpack_require__(165)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(87),
  /* template */
  __webpack_require__(252),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0064b68e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(184)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(88),
  /* template */
  __webpack_require__(270),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5288f8c6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(186)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(272),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-57fa06d3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(189)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(90),
  /* template */
  __webpack_require__(275),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-794598f1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(190)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(91),
  /* template */
  __webpack_require__(276),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7bc7efb8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(193)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(279),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-89e459a2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(170)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(93),
  /* template */
  __webpack_require__(257),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-15269659",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(178)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(94),
  /* template */
  __webpack_require__(264),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-399053ae",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(180)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(266),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-41a9cbda",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(168)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(96),
  /* template */
  __webpack_require__(255),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-111bad3e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(195)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(97),
  /* template */
  __webpack_require__(281),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a92d20d4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(181)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(267),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-427e4852",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(167)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(99),
  /* template */
  __webpack_require__(254),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0cb7339c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(187)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(100),
  /* template */
  __webpack_require__(273),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-62c88866",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(183)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(269),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4f6c0ace",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(196)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(102),
  /* template */
  __webpack_require__(282),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b8ecdffa",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(188)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(103),
  /* template */
  __webpack_require__(274),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-644a7f72",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(198)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(284),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-de25a072",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(182)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(105),
  /* template */
  __webpack_require__(268),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-42f3dc46",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(173)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(106),
  /* template */
  __webpack_require__(259),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2356a398",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(192)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(278),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7fbb25fd",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(197)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(108),
  /* template */
  __webpack_require__(283),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-bc083e30",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(179)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(109),
  /* template */
  __webpack_require__(265),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3db1e588",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(185)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(271),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-54fef1bd",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(177)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(112),
  /* template */
  __webpack_require__(263),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(260),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(166)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(114),
  /* template */
  __webpack_require__(253),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-022e942e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(176)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(115),
  /* template */
  __webpack_require__(262),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3627bb08",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(194)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(280),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-99b8285a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 252 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "column-sortable",
    class: _vm.sortOrderClass,
    attrs: {
      "title": _vm.data.tooltip
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.$emit("toggleOrder", _vm.data.id)
      }
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.data.label)
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 253 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row report-template report-template-editing"
  }, [_c('div', {
    staticClass: "col-md-9 contents"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-md-3",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Template Name:")]), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.template.name),
      expression: "template.name"
    }],
    staticClass: "col-md-12 title",
    attrs: {
      "id": "name",
      "type": "text",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.template.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.template, "name", $event.target.value)
      }
    }
  })]), _c('label', {
    staticClass: "col-md-3",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Template Short Name:")]), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.template.name_short),
      expression: "template.name_short"
    }],
    staticClass: "col-md-12 title_short",
    attrs: {
      "id": "name_short",
      "type": "text",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.template.name_short)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.template, "name_short", $event.target.value)
      }
    }
  })]), _c('label', {
    staticClass: "col-md-3",
    attrs: {
      "for": "tod"
    }
  }, [_vm._v("Day of Week")]), _c('div', {
    staticClass: "col-md-9"
  }, [_c('vue-multiselect', {
    attrs: {
      "value": _vm.dow,
      "options": _vm.days,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": false,
      "hide-selected": true,
      "preserve-search": true,
      "placeholder": "Day"
    },
    on: {
      "input": _vm.setDays
    },
    scopedSlots: _vm._u([{
      key: "tag",
      fn: function(props) {
        return [_c('span', {
          staticClass: "custom__tag"
        }, [_c('span', [_vm._v(_vm._s(props.option))]), _c('span', {
          staticClass: "custom__remove",
          on: {
            "click": function($event) {
              return props.remove(props.option)
            }
          }
        }, [_vm._v("❌")])])]
      }
    }])
  })], 1), _c('label', {
    staticClass: "col-md-3",
    attrs: {
      "for": "tod"
    }
  }, [_vm._v("Time Of Day")]), _c('div', {
    staticClass: "col-md-9"
  }, [_c('vue-multiselect', {
    attrs: {
      "value": _vm.tod,
      "options": _vm.hours,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": false,
      "hide-selected": true,
      "preserve-search": true,
      "placeholder": "Hour"
    },
    on: {
      "input": _vm.setHours
    },
    scopedSlots: _vm._u([{
      key: "tag",
      fn: function(props) {
        return [_c('span', {
          staticClass: "custom__tag"
        }, [_c('span', [_vm._v(_vm._s(props.option))]), _c('span', {
          staticClass: "custom__remove",
          on: {
            "click": function($event) {
              return props.remove(props.option)
            }
          }
        }, [_vm._v("❌")])])]
      }
    }])
  })], 1), _c('div', {
    staticClass: "col-md-12 field intro"
  }, [_c('label', {
    staticClass: "col-md-12",
    attrs: {
      "for": "intro"
    }
  }, [_vm._v("Intro:")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.template.intro),
      expression: "template.intro"
    }],
    staticClass: "form-control col-md-12",
    attrs: {
      "rows": "10",
      "placeholder": "Intro Text"
    },
    domProps: {
      "value": (_vm.template.intro)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.template, "intro", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "col-md-12 field outro"
  }, [_c('label', {
    staticClass: "col-md-12",
    attrs: {
      "for": "outro"
    }
  }, [_vm._v("Outro:")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.template.close),
      expression: "template.close"
    }],
    staticClass: "form-control col-md-12",
    attrs: {
      "rows": "10",
      "placeholder": "Outro Text"
    },
    domProps: {
      "value": (_vm.template.close)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.template, "close", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-md-3 images"
  }, [_c('div', [_vm._v("Images:")]), _c('b-button', {
    attrs: {
      "size": "sm"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.toggleImagesExpanded.apply(null, arguments)
      }
    }
  }, [_vm._v("Toggle Details")])], 1), (_vm.imagesExpanded) ? _c('draggable', {
    staticClass: "col-md-9 row images",
    model: {
      value: (_vm.images),
      callback: function($$v) {
        _vm.images = $$v
      },
      expression: "images"
    }
  }, _vm._l((_vm.images), function(image) {
    return _c('div', {
      staticClass: "row image"
    }, [_c('div', {
      staticClass: "col-md-12 field"
    }, [_c('label', {
      staticClass: "col-md-2",
      attrs: {
        "for": "title"
      }
    }, [_vm._v("Title:")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (image.title),
        expression: "image.title"
      }],
      staticClass: "col-md-10 title",
      attrs: {
        "id": "title",
        "type": "text",
        "placeholder": "Title"
      },
      domProps: {
        "value": (image.title)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(image, "title", $event.target.value)
        }
      }
    })]), _c('div', {
      staticClass: "col-md-12 field"
    }, [_c('label', {
      staticClass: "col-md-2",
      attrs: {
        "for": "text"
      }
    }, [_vm._v("Text:")]), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (image.text),
        expression: "image.text"
      }],
      staticClass: "form-control col-md-10 text",
      attrs: {
        "id": "text",
        "rows": "5",
        "placeholder": "Text"
      },
      domProps: {
        "value": (image.text)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(image, "text", $event.target.value)
        }
      }
    })]), _c('div', {
      staticClass: "col-md-12 field"
    }, [_c('label', {
      staticClass: "col-md-2",
      attrs: {
        "for": "url"
      }
    }, [_vm._v("URL:")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (image.url),
        expression: "image.url"
      }],
      staticClass: "col-md-10 url",
      attrs: {
        "id": "url",
        "type": "text",
        "placeholder": "URL"
      },
      domProps: {
        "value": (image.url)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(image, "url", $event.target.value)
        }
      }
    })]), _c('div', {
      staticClass: "col-md-12 field"
    }, [_c('label', {
      staticClass: "col-md-2",
      attrs: {
        "for": "timeout"
      }
    }, [_vm._v("timeout:")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (image.timeout),
        expression: "image.timeout"
      }],
      staticClass: "col-md-10 url",
      attrs: {
        "id": "delay",
        "type": "number",
        "min": "1",
        "max": "180",
        "placeholder": "Timeout"
      },
      domProps: {
        "value": (image.timeout)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(image, "timeout", $event.target.value)
        }
      }
    })]), _c('div', {
      staticClass: "col-md-12 field"
    }, [_c('label', {
      staticClass: "col-md-2",
      attrs: {
        "for": "width"
      }
    }, [_vm._v("width:")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (image.width),
        expression: "image.width"
      }],
      staticClass: "col-md-10 url",
      attrs: {
        "id": "delay",
        "type": "number",
        "min": "1",
        "max": "180",
        "placeholder": "Width"
      },
      domProps: {
        "value": (image.width)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(image, "width", $event.target.value)
        }
      }
    })]), _c('div', {
      staticClass: "col-md-12 field"
    }, [_c('label', {
      staticClass: "col-md-2",
      attrs: {
        "for": "height"
      }
    }, [_vm._v("height:")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (image.height),
        expression: "image.height"
      }],
      staticClass: "col-md-10 url",
      attrs: {
        "id": "delay",
        "type": "number",
        "min": "1",
        "max": "180",
        "placeholder": "Height"
      },
      domProps: {
        "value": (image.height)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(image, "height", $event.target.value)
        }
      }
    })]), _c('div', {
      staticClass: "col-md-4 push-md-8 actions"
    }, [_c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "danger"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.onDeleteImage(image)
        }
      }
    }, [_vm._v("Delete")])], 1)])
  }), 0) : _c('draggable', {
    staticClass: "col-md-9 row images",
    model: {
      value: (_vm.images),
      callback: function($$v) {
        _vm.images = $$v
      },
      expression: "images"
    }
  }, _vm._l((_vm.images), function(image) {
    return _c('div', {
      staticClass: "row image collapsed col-md-12"
    }, [_c('strong', {
      staticClass: "col-md-12"
    }, [_vm._v(_vm._s(image.title))])])
  }), 0), _c('footer', {
    staticClass: "row col-md-12"
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onAddImage.apply(null, arguments)
      }
    }
  }, [_vm._v("Add Image")])], 1)], 1)]), _c('div', {
    staticClass: "col-md-3 actions"
  }, [_c('b-button', {
    attrs: {
      "size": "sm"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onCancel.apply(null, arguments)
      }
    }
  }, [_vm._v("Cancel")]), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onSave.apply(null, arguments)
      }
    }
  }, [_vm._v("Save")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 254 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hollow-dots-spinner",
    style: (_vm.spinnerStyle)
  }, _vm._l((_vm.dotsStyles), function(ds, index) {
    return _c('div', {
      key: index,
      staticClass: "dot",
      style: (ds)
    })
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 255 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fulfilling-bouncing-circle-spinner",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "circle",
    style: (_vm.circleStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "orbit",
    style: (_vm.orbitStyle)
  })])
},staticRenderFns: []}

/***/ }),
/* 256 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', _vm._l((_vm.rows), function(row) {
    return _c('table-row', {
      key: row.key,
      attrs: {
        "data": row,
        "columns": _vm.columns
      }
    })
  }), 1)
},staticRenderFns: []}

/***/ }),
/* 257 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "circles-to-rhombuses-spinner",
    style: (_vm.spinnertStyle)
  }, _vm._l((_vm.circlesStyles), function(cs, index) {
    return _c('div', {
      key: index,
      staticClass: "circle",
      style: (cs)
    })
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 258 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.user.user_nicename) ? _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.isLoading) ? _c('div', {
    attrs: {
      "id": "loading"
    }
  }, [_c('orbit-spinner', {
    attrs: {
      "animation-duration": 1200,
      "size": 55,
      "color": "#24890d"
    }
  })], 1) : _vm._e(), _c('h1', [_vm._v("Ansergy Email Reports")]), _c('h3', [_vm._v(_vm._s(_vm.user.user_nicename))]), _c('br'), _c('report-template-list')], 1) : _c('div', {
    attrs: {
      "id": "loading"
    }
  }, [_c('h4', [_vm._v("Loading ...")]), _c('orbit-spinner', {
    attrs: {
      "animation-duration": 1200,
      "size": 55,
      "color": "#24890d"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 259 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "self-building-square-spinner",
    style: (_vm.spinnerStyle)
  }, _vm._l((_vm.squaresStyles), function(ss, index) {
    return _c('div', {
      key: index,
      staticClass: "square",
      class: {
        'clear': index && index % 3 === 0
      },
      style: (ss)
    })
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 260 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row report-list"
  })
},staticRenderFns: []}

/***/ }),
/* 261 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tfoot', {
    attrs: {
      "id": "no-pdf"
    }
  }, [_c('td', {
    attrs: {
      "colspan": "10"
    }
  }, [_c('div', {
    staticClass: "datatable-controls no-pdf"
  }, [_c('a', {
    staticClass: "button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.downloadPDF
    }
  }, [_vm._v("Download PDF")]), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.downloadCSV
    }
  }, [_vm._v("Download CSV")]), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.downloadXLS
    }
  }, [_vm._v("Download XLS")])])])])
},staticRenderFns: []}

/***/ }),
/* 262 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report-template-list"
  }, [_vm._l((_vm.reportTemplates), function(template) {
    return _c('report-template', {
      key: "id",
      attrs: {
        "template": template,
        "isEditing": !template.id
      }
    })
  }), _c('footer', [_c('div', {
    staticClass: "actions"
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.addNewTemplate.apply(null, arguments)
      }
    }
  }, [_vm._v("Add Template")])], 1)])], 2)
},staticRenderFns: []}

/***/ }),
/* 263 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "all-reports"
    }
  }, [_c('h2', [_vm._v("All Reports")]), _c('b-button-toolbar', [_c('b-button-group', {
    staticClass: "mx-1"
  }, [_c('b-button', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onExport.apply(null, arguments)
      }
    }
  }, [_vm._v("Export")])], 1), _c('b-button-group', {
    staticClass: "mx-1"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal",
      value: ('modalUploadReports'),
      expression: "'modalUploadReports'"
    }]
  }, [_vm._v("Import")]), _c('b-modal', {
    ref: "modalUploadReports",
    attrs: {
      "id": "modalUploadReports",
      "size": "lg",
      "title": "Upload reports file"
    },
    on: {
      "ok": function($event) {
        return _vm.$refs.importForm.submit()
      }
    }
  }, [_vm._t("modal-header", function() {
    return [_c('b-alert', {
      staticClass: "alert-danger",
      attrs: {
        "show": "show"
      }
    }, [_vm._v("Danger! Importing reports will\n"), _c('strong', [_vm._v("delete all existing reports")]), _vm._v(" before adding the new ones.\nUse with caution.")])]
  }), _c('form', {
    ref: "importForm",
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
      }
    }
  }, [_c('b-form-file', {
    attrs: {
      "type": "file",
      "placeholder": "Add CSV file"
    },
    on: {
      "change": _vm.onImport
    },
    model: {
      value: (_vm.file),
      callback: function($$v) {
        _vm.file = $$v
      },
      expression: "file"
    }
  })], 1), (_vm.importRows.length > 0) ? _c('div', {
    staticClass: "preview"
  }, [_c('datatable', {
    staticClass: "import-results",
    attrs: {
      "title": "Import Preview",
      "columns": _vm.columns,
      "rows": _vm.importRows
    }
  }), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.setAllReports(_vm.importRows)
      }
    }
  }, [_vm._v("Confirm Import")])], 1) : _vm._e()], 2)], 1)], 1), (_vm.allReports.length > 0) ? _c('datatable', {
    staticClass: "all-reports",
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.allReports
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 264 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fingerprint-spinner",
    style: (_vm.spinnerStyle)
  }, _vm._l((_vm.ringsStyles), function(rs, index) {
    return _c('div', {
      key: index,
      staticClass: "spinner-ring",
      style: (rs)
    })
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 265 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swapping-squares-spinner",
    style: (_vm.spinnerStyle)
  }, _vm._l((_vm.squaresStyles), function(ss, index) {
    return _c('div', {
      key: index,
      staticClass: "square",
      class: ("square-" + (index + 1)),
      style: (ss)
    })
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 266 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flower-spinner",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "dots-container",
    style: (_vm.dotsContainerStyle)
  }, [_c('div', {
    staticClass: "big-dot",
    style: (_vm.biggerDotStyle)
  }, [_c('div', {
    staticClass: "small-dot",
    style: (_vm.smallerDotStyle)
  })])])])
},staticRenderFns: []}

/***/ }),
/* 267 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "half-circle-spinner",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "circle circle-1",
    style: (_vm.circle1Style)
  }), _vm._v(" "), _c('div', {
    staticClass: "circle circle-2",
    style: (_vm.circle2Style)
  })])
},staticRenderFns: []}

/***/ }),
/* 268 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scaling-squares-spinner",
    style: (_vm.spinnerStyle)
  }, _vm._l((_vm.squaresStyles), function(ss, index) {
    return _c('div', {
      key: index,
      staticClass: "square",
      class: ("square-" + (index + 1)),
      style: (ss)
    })
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 269 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "looping-rhombuses-spinner",
    style: (_vm.spinnerStyle)
  }, _vm._l((_vm.rhombusesStyles), function(rs, index) {
    return _c('div', {
      staticClass: "rhombus",
      style: (rs),
      attrs: {
        "ikey": index
      }
    })
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 270 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": _vm.columns.length
    },
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  })]), _c('tr', _vm._l((_vm.columns), function(column) {
    return _c('table-header-cell', {
      key: column.id,
      attrs: {
        "data": column
      },
      on: {
        "toggleOrder": function($event) {
          return _vm.toggleOrder(column.id)
        }
      }
    })
  }), 1)])
},staticRenderFns: []}

/***/ }),
/* 271 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "trinity-rings-spinner",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "circle circle1",
    style: (_vm.ring1Style)
  }), _vm._v(" "), _c('div', {
    staticClass: "circle circle2",
    style: (_vm.ring2Style)
  }), _vm._v(" "), _c('div', {
    staticClass: "circle circle3",
    style: (_vm.ring3Style)
  })])
},staticRenderFns: []}

/***/ }),
/* 272 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-pagination"
  }, [_c('div', {
    staticClass: "pages"
  }, [_c('div', {
    staticClass: "page page-previous",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onPreviousPage.apply(null, arguments)
      }
    }
  }, [_vm._v("«")]), _vm._l((_vm.pages), function(page) {
    return _c('div', {
      staticClass: "page",
      class: _vm.pageClasses(page),
      domProps: {
        "innerHTML": _vm._s(page)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.setPage(page)
        }
      }
    })
  }), _c('div', {
    staticClass: "page page--next",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onNextPage.apply(null, arguments)
      }
    }
  }, [_vm._v("»")])], 2)])
},staticRenderFns: []}

/***/ }),
/* 273 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intersecting-circles-spinner",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "spinnerBlock",
    style: (_vm.spinnerBlockStyle)
  }, _vm._l((_vm.circleStyles), function(cs, index) {
    return _c('span', {
      key: index,
      staticClass: "circle",
      style: (cs)
    })
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 274 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pixel-spinner",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "pixel-spinner-inner",
    style: (_vm.spinnerInnerStyle)
  })])
},staticRenderFns: []}

/***/ }),
/* 275 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', _vm._l((_vm.columns), function(column) {
    return _c('td', {
      domProps: {
        "innerHTML": _vm._s(_vm.data[column.id])
      }
    })
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 276 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "atom-spinner",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "spinner-inner"
  }, [_c('div', {
    staticClass: "spinner-line",
    style: (_vm.lineStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "spinner-line",
    style: (_vm.lineStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "spinner-line",
    style: (_vm.lineStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "spinner-circle",
    style: (_vm.circleStyle)
  }, [_vm._v("\n      ●\n    ")])])])
},staticRenderFns: []}

/***/ }),
/* 277 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "datatable"
  }, [_c('table', [_c('TableHeader', {
    attrs: {
      "title": _vm.title,
      "columns": _vm.Columns
    },
    on: {
      "toggleOrder": _vm.toggleOrder
    }
  }), _c('TableBody', {
    attrs: {
      "columns": _vm.Columns,
      "rows": _vm.Rows
    }
  }), _c('TableFooter', {
    attrs: {
      "columns": _vm.Columns,
      "rows": _vm.Rows
    }
  })], 1), _c('TablePagination', {
    attrs: {
      "page": _vm.page,
      "totalPages": _vm.totalPages
    },
    on: {
      "setPage": _vm.setPage
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 278 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "semipolar-spinner",
    style: (_vm.spinnerStyle)
  }, _vm._l((_vm.ringsStyles), function(rs, index) {
    return _c('div', {
      key: index,
      staticClass: "ring",
      style: (rs)
    })
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 279 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "breeding-rhombus-spinner",
    style: (_vm.spinnerStyle)
  }, [_vm._l((_vm.rhombusesStyles), function(rs, index) {
    return _c('div', {
      key: index,
      staticClass: "rhombus",
      class: ("child-" + (index + 1)),
      style: (rs)
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "rhombus big",
    style: (_vm.bigRhombusStyle)
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 280 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.editing) ? _c('div', {
    staticClass: "row report-template",
    attrs: {
      "data-id": _vm.template.id
    }
  }, [_c('div', {
    staticClass: "col-md-9 contents"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('strong', {
    staticClass: "col-md-12 title",
    domProps: {
      "innerHTML": _vm._s(_vm.templateName(_vm.template))
    }
  })]), (_vm.isExpanded) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-11 push-md-1 field intro"
  }, [_c('strong', [_vm._v("Day Of Week")]), _c('p', [_vm._v(_vm._s(_vm.template.dow))])]), _c('div', {
    staticClass: "col-md-11 push-md-1 field intro"
  }, [_c('strong', [_vm._v("Time Of Day")]), _c('p', [_vm._v(_vm._s(_vm.template.tod))])]), _c('div', {
    staticClass: "col-md-11 push-md-1 field intro"
  }, [_c('strong', [_vm._v("Intro:")]), _c('p', [_vm._v(_vm._s(_vm.template.intro))])]), _c('div', {
    staticClass: "col-md-11 push-md-1 field outro"
  }, [_c('strong', [_vm._v("Outro:")]), _c('p', [_vm._v(_vm._s(_vm.template.close))])]), _c('div', {
    staticClass: "col-md-10 push-md-2 images"
  }, [_c('strong', [_vm._v("Images:")]), _vm._l((_vm.images), function(image) {
    return _c('div', {
      staticClass: "image"
    }, [_c('strong', {
      staticClass: "row col-md-12 title"
    }, [_vm._v(_vm._s(image.title))]), _c('div', {
      staticClass: "row col-md-12 text"
    }, [_vm._v(_vm._s(image.text))]), (image.timeout) ? _c('div', {
      staticClass: "row timeout"
    }, [_c('strong', {
      staticClass: "col-md-2"
    }, [_vm._v("Timeout:")]), _c('span', {
      staticClass: "col-md-2"
    }, [_vm._v(_vm._s(image.timeout))])]) : _vm._e(), (image.width) ? _c('div', {
      staticClass: "row width"
    }, [_c('strong', {
      staticClass: "col-md-2"
    }, [_vm._v("Width:")]), _c('span', {
      staticClass: "col-md-2"
    }, [_vm._v(_vm._s(image.width))])]) : _vm._e(), (image.height) ? _c('div', {
      staticClass: "row height"
    }, [_c('strong', {
      staticClass: "col-md-2"
    }, [_vm._v("Height:")]), _c('span', {
      staticClass: "col-md-2"
    }, [_vm._v(_vm._s(image.height))])]) : _vm._e()])
  })], 2)]) : _vm._e()]), _c('div', {
    staticClass: "col-md-3 actions"
  }, [_c('b-button', {
    attrs: {
      "size": "sm"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onToggleExpand.apply(null, arguments)
      }
    }
  }, [(!_vm.isExpanded) ? _c('span', [_vm._v("More")]) : _vm._e(), (_vm.isExpanded) ? _c('span', [_vm._v("Less")]) : _vm._e()]), _c('b-button', {
    attrs: {
      "size": "sm"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onEdit.apply(null, arguments)
      }
    }
  }, [_vm._v("Edit")]), _c('b-button', {
    attrs: {
      "size": "sm"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onCopy.apply(null, arguments)
      }
    }
  }, [_vm._v("Copy")]), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "danger"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onDelete.apply(null, arguments)
      }
    }
  }, [_vm._v("Delete")])], 1)]) : _c('report-template-form', {
    attrs: {
      "template": _vm.template
    },
    on: {
      "save": function($event) {
        _vm.editing = false
      },
      "cancel": function($event) {
        _vm.editing = false
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 281 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fulfilling-square-spinner",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.spinnerInnerStyle)
  })])
},staticRenderFns: []}

/***/ }),
/* 282 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "orbit-spinner",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "orbit one",
    style: (_vm.orbitStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "orbit two",
    style: (_vm.orbitStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "orbit three",
    style: (_vm.orbitStyle)
  })])
},staticRenderFns: []}

/***/ }),
/* 283 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spring-spinner",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "spring-spinner-part top",
    style: (_vm.spinnerPartStyle)
  }, [_c('div', {
    staticClass: "spring-spinner-rotator",
    style: (_vm.rotatorStyle)
  })]), _vm._v(" "), _c('div', {
    staticClass: "spring-spinner-part bottom",
    style: (_vm.spinnerPartStyle)
  }, [_c('div', {
    staticClass: "spring-spinner-rotator",
    style: (_vm.rotatorStyle)
  })])])
},staticRenderFns: []}

/***/ }),
/* 284 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "radar-spinner",
    style: (_vm.spinnerStyle)
  }, _vm._l((_vm.circlesStyles), function(cs, index) {
    return _c('div', {
      key: index,
      staticClass: "circle",
      style: (cs)
    }, [_c('div', {
      staticClass: "circle-inner-container",
      style: (_vm.circleInnerContainerStyle)
    }, [_c('div', {
      staticClass: "circle-inner",
      style: (_vm.circleInnerStyle)
    })])])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 290 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 291 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
]),[83]);


// WEBPACK FOOTER //
// static/js/app.9f0f80b82cb09fa4f0b6.js